<tr class="item-line fst">
  <td>
    <b>{{ item.name }}</b>
  </td>
  <td [class.text-center]="document.type !== 'write-off'" [class.text-right]="document.type === 'write-off'">
    {{ item.quantity | pepNumber: 4 }}
  </td>
  <td class="text-center" *ngIf="
      document.hasUnit && document.type !== 'write-off'
    ">
    {{ item.unit }}
  </td>
  <td class="text-center" *ngIf="document.type !== 'write-off'">
    {{
    item.price
    | pepCurrency: document.currencyId:locale
    }}
  </td>
  <td class="text-center" *ngIf="!!document.totalDiscount && document.type !== 'write-off'">
    <ng-container *ngIf="!item.discountIsAmount; else discountIsAmount">
      {{ item.discount | pepNumber }}%
    </ng-container>
    <ng-template #discountIsAmount>
      {{
      item.discount
      | pepCurrency
      : document.currencyId
      : locale
      }}
    </ng-template>
  </td>
  <td class="text-center" *ngIf="document._documentTaxes?.length && document.type !== 'write-off'">
    <span *ngFor="
        let tax of item._documentItemTaxes;
        let i = index
      " [class.mt-1]="i > 1">{{ tax.rate | pepNumber }}%<br /></span>
  </td>
  <td class="text-right" *ngIf="document.total !== document.totalWithTax && document.type !== 'write-off'">
    {{
    item.totalTax
    | pepCurrency: document.currencyId:locale
    }}
  </td>
  <td class="text-right" *ngIf="document.type !== 'write-off'">
    {{
    item.total
    | pepCurrency: document.currencyId:locale
    }}
  </td>
  <td class="text-right" *ngIf="
      document.type !== 'write-off' &&
      document.total !== document.totalWithTax &&
      !document._documentClient.taxSubject
    ">
    {{
    item.totalWithTax
    | pepCurrency: document.currencyId:locale
    }}
  </td>
</tr>
<tr class="item-line-desc snd" *ngIf="item.description">
  <td class="whitespace-pre pt-2 border-top-0" colspan="9">{{ lod(item, 'description') }}</td>
</tr>